import { render, staticRenderFns } from "./AllBuildingsPage.vue?vue&type=template&id=62318d8c&scoped=true&"
import script from "./AllBuildingsPage.vue?vue&type=script&lang=js&"
export * from "./AllBuildingsPage.vue?vue&type=script&lang=js&"
import style0 from "./AllBuildingsPage.vue?vue&type=style&index=0&id=62318d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62318d8c",
  null
  
)

export default component.exports